// extracted by mini-css-extract-plugin
export default {"wrapper":"verificationEmailHoc_wrapper__I7fok"};